// -- import * as _ from "lodash-es"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    { key: 'QuotationTaskId', label: '编号', sortable: true, thStyle: { width: "60px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "fcCheckSQOrderApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSQOrderApproved",
      other_type_key: "isOrderRefused",
      context: ["待审批", "已审批", "已退回"]
    },
    { key: "SQOrderApprover", label: "待审批人", sortable: true, thStyle: { width: "8rem" } },
    {
      key: 'SQOrderApproveRemark', label: '审批意见', sortable: true, type: 'html',
      thStyle: { width: "12rem" },
    },
    {
      key: 'SQOrderDescription', label: '退回原因', sortable: true, type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'QuotationTaskLineNum', label: '报价单行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true,
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", required: true, },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", required: true, },
    { key: 'task_detail_description', label: '描述', sortable: true, type: "short", thStyle: { width: "8rem" } },
    { key: 'PriceDescription', label: '价格说明', sortable: true, type: "short", thStyle: { width: "8rem" } },
    {
      key: 'DistributionRate', label: '分配率(%)', sortable: true,
      type: "number",
      thStyle: {
        width: "6rem"
      }
    },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", required: true, },
    { key: 'Currency', label: '币种', sortable: true, thStyle: { width: "8rem" } },
    { key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "just_number", thStyle: { width: "8rem" } },
    { key: 'TotalCost', label: '综合成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'TargetGrossProfitMargin', label: '目标毛利率(%)', sortable: true, type: "number", thStyle: { width: "7rem" }, },
    { key: 'GrossProfitMargin', label: '毛利率(%)', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
  ],
  weighted_cost_confirm: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "8rem" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'QuotationTaskLineNum', label: '报价申请行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true,
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    {
      key: 'DistributionRate', label: '分配率(%)', sortable: true,
      type: "number",
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    { key: 'task_detail_description', label: '描述', sortable: true, type: "short", thStyle: { width: "8rem" } },
    { key: 'PriceDescription', label: '价格说明', sortable: true, type: "short", thStyle: { width: "8rem" } },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", required: true, },
    { key: 'Currency', label: '币种', sortable: true, thStyle: { width: "8rem" } },
    { key: 'ExchangeRate', label: '汇率', sortable: true, type: "number", thStyle: { width: "6rem" } },
    { key: 'Price_WOTax', label: '本币不含税报价', sortable: true, type: "just_number", thStyle: { width: "8rem" } },
    { key: 'WeightedCost', label: '加权成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'OtherCost', label: '其它费用', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'TotalCost', label: '综合成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'TargetGrossProfitMargin', label: '目标毛利率(%)', sortable: true, type: "number", thStyle: { width: "7rem" }, },
    { key: 'GrossProfitMargin', label: '毛利率(%)', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'WeightCostCreateAt', label: '创建时间', sortable: true, type: "datetime" },
    { key: 'WeightCostCreateUser', label: '主计划审批人', sortable: true },
    {
      key: "SalesQuoteWeightCostApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "SalesQuoteWeightCostApproved",
      context: ["待审批", "已审批"]
    },
    { key: "SalesQuoteWeightCostApprover", label: "审批人", sortable: true, thStyle: { width: "8rem" } },
    {
      key: 'ApproveRemark', label: '审批意见', sortable: true, type: 'html',
      thStyle: { width: "12rem" },
    }
  ],
  quotation_proofing: [
    { key: 'QuotationTaskId', label: '编号', sortable: true, thStyle: { width: "60px" } },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "ProofingOrderStatus",
      label: "单据状态",
      sortable: true,
      type: "state",
      state_control: "ProofingOrderStatus",
    },

    { key: 'QuotationTaskLineNum', label: '报价单行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true,
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", required: true },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", required: true },
    { key: 'Price', label: '申请报价', sortable: true, type: "just_number", required: true },
    { key: 'Currency', label: '币种', sortable: true, thStyle: { width: "8rem" } },
    { key: 'task_detail_description', label: '描述', sortable: true, type: "short", thStyle: { width: "8rem" } },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "70px" }
    },
    { key: 'PriceDescription', label: '价格说明', sortable: true, type: "short", thStyle: { width: "8rem" } },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "datetime" },
    {
      key: 'DistributionRate', label: '分配率(%)', sortable: true,
      type: "number",
      thStyle: {
        width: "6rem"
      }
    },
    { key: "AccountName", label: "供应商(TPM)", sortable: true, thStyle: { width: "12rem" }, width: "12rem" },
    { key: 'PerPrice', label: '供应商报价(TPM)', sortable: true, type: "just_number", required: true },
    {
      key: 'VendAccessory',
      label: '供应商附件(TPM)',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    { key: "PurchAccountName", label: "供应商(采购)", sortable: true, thStyle: { width: "12rem" }, width: "12rem" },
    { key: 'PurchPerPrice', label: '供应商报价(采购)', sortable: true, type: "just_number", required: true },
    {
      key: 'PurchVendAccessory',
      label: '供应商附件(采购)',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    }

  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  async getData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_quotation_order", {}, {})
    let f = _.map(fields.default, "key")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getProofingData(_params) {
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_quotation_order_proofing", {}, {})
    let f = _.map(fields.default, "key")
    let result = await detail_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
}
export { biz_data, dataForm, fields, methods, rules }

